import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

export const getDefaultState = () => {
    return {
        error: null,
        loading: false,
        data: {
            code: code,
            codeAPI: codeAPI,
            module: {},
            panels: {
                home: {
                    menu: {
                        route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                        text: 'home.title',
                        icon: 'fas fa-home',
                    },
                    acl: {
                        view: null,
                    },
                },
                settings: {
                    menu: {
                        route: `${code}.settings`,
                        text: `settings.titles`,
                        icon: 'fas fa-cogs',
                    },
                    acl: {
                        view                    : 'acl',
                        edit                    : 'acl',
                    },
                    url: {
                        getConfig               : `/${codeAPI}/:applicationCode/gestao/definitions`,
                    },
                },

                //////////////
                // LAYOUT MAP
                //////////////
                default_layers: {
                    menu: {
                        route: `${code}.default_layers`,
                        text: 'default_layers.titles',
                        icon: 'fas fa-layer-group',
                    },
                    acl: {
                        view                    : 'acl',
                        detail                  : 'acl',
                        add                     : 'acl',
                        edit                    : 'acl',
                        delete                  : 'acl',
                    },
                    url: {
                        getList                 : `${codeAPI}/:applicationCode/gestao/map/defaultlayers`,
                        getShow                 : `${codeAPI}/:applicationCode/gestao/map/defaultlayers/:id`,
                        getCreate               : `${codeAPI}/:applicationCode/gestao/map/defaultlayers`,
                        getUpdate               : `${codeAPI}/:applicationCode/gestao/map/defaultlayers/:id`,
                        getDelete               : `${codeAPI}/:applicationCode/gestao/map/defaultlayers/:id`,
                        getLists                : `${codeAPI}/:applicationCode/gestao/map/defaultlayers/lists`,
                        getResources            : `${codeAPI}/:applicationCode/gestao/map/defaultlayers/resources`,
                    },
                },
                layers: {
                    menu: {
                        route: `${code}.layers`,
                        text: `layers.titles`,
                        icon: 'fas fa-layer-group',
                    },
                    acl: {
                        view                    : 'acl',
                        detail                  : 'acl',
                        add                     : 'acl',
                        edit                    : 'acl',
                        delete                  : 'acl',
                        private                 : 'acl',
                    },
                    url: {
                        getList                 : `${codeAPI}/:applicationCode/gestao/map/layers`,
                        getShow                 : `${codeAPI}/:applicationCode/gestao/map/layers/:id`,
                        getCreate               : `${codeAPI}/:applicationCode/gestao/map/layers`,
                        getUpdate               : `${codeAPI}/:applicationCode/gestao/map/layers/:id`,
                        getDelete               : `${codeAPI}/:applicationCode/gestao/map/layers/:id`,
                        getLists                : `${codeAPI}/:applicationCode/gestao/map/layers/lists`,
                        getResources            : `${codeAPI}/:applicationCode/gestao/map/layers/resources`,
                        describeResource        : `${codeAPI}/:applicationCode/gestao/map/layers/resources/:id/describe`,
                    },
                },
                regulations: {
                    menu: {
                        route: `${code}.regulations`,
                        text: `regulations.titles`,
                        icon: 'fas fa-book',
                    },
                    acl: {
                        view                    : 'acl',
                        detail                  : 'acl',
                        add                     : 'acl',
                        edit                    : 'acl',
                        delete                  : 'acl',
                    },
                    url: {
                        getList                 : `${codeAPI}/:applicationCode/gestao/map/regulations`,
                        getShow                 : `${codeAPI}/:applicationCode/gestao/map/regulations/:id`,
                        getCreate               : `${codeAPI}/:applicationCode/gestao/map/regulations`,
                        getUpdate               : `${codeAPI}/:applicationCode/gestao/map/regulations/:id`,
                        getDelete               : `${codeAPI}/:applicationCode/gestao/map/regulations/:id`,
                        getLists                : `${codeAPI}/:applicationCode/gestao/map/regulations/lists`,
                    },
                },
                print_visible_emissions: {
                    menu: {
                        route: `${code}.print_visible_emissions.config`,
                        text: `print_visible_emissions.titles`,
                        icon: 'fas fa-print',
                    },
                    acl: {
                        view                    : 'acl',
                        config                  : 'acl',
                        configEdit              : 'acl',
                    },
                    url: {
                        getList                 : `/${codeAPI}/:applicationCode/gestao/map/printvisible`,
                        getConfig               : `/${codeAPI}/:applicationCode/gestao/map/printvisible/settings`,
                        getApps                 : `/${codeAPI}/:applicationCode/gestao/map/printvisible/print/apps`,
                    },
                },


                //////////////
                // LAYOUT OS
                //////////////
                pages: {
                    menu: {
                        route: `${code}.pages`,
                        text: `pages.titles`,
                        icon: 'fas fa-book',
                    },
                    acl: {
                        view                    : 'acl',
                        detail                  : 'acl',
                        add                     : 'acl',
                        edit                    : 'acl',
                        delete                  : 'acl',
                    },
                    url: {
                        getLists                : `${codeAPI}/:applicationCode/gestao/os/pages/lists`,
                        getList                 : `${codeAPI}/:applicationCode/gestao/os/pages`,
                        getShow                 : `${codeAPI}/:applicationCode/gestao/os/pages/:id`,
                        getCreate               : `${codeAPI}/:applicationCode/gestao/os/pages`,
                        getUpdate               : `${codeAPI}/:applicationCode/gestao/os/pages/:id`,
                        getDelete               : `${codeAPI}/:applicationCode/gestao/os/pages/:id`,
                        quickUpload             : `${codeAPI}/:applicationCode/gestao/os/pages/quickupload`,
                        preview                 : `${codeAPI}/:applicationCode/gestao/os/pages/single/:slug/preview`
                    },
                },
                page_categories: {
                    menu: {
                        route: `${code}.page_categories`,
                        text: `page_categories.titles`,
                        icon: 'fas fa-book',
                    },
                    acl: {
                        view                    : 'acl',
                        detail                  : 'acl',
                        add                     : 'acl',
                        edit                    : 'acl',
                        delete                  : 'acl',
                    },
                    url: {
                        getLists                : `${codeAPI}/:applicationCode/gestao/os/pagecategories/lists`,
                        getList                 : `${codeAPI}/:applicationCode/gestao/os/pagecategories`,
                        getShow                 : `${codeAPI}/:applicationCode/gestao/os/pagecategories/:id`,
                        getCreate               : `${codeAPI}/:applicationCode/gestao/os/pagecategories`,
                        getUpdate               : `${codeAPI}/:applicationCode/gestao/os/pagecategories/:id`,
                        getDelete               : `${codeAPI}/:applicationCode/gestao/os/pagecategories/:id`,
                    },
                },
            },
            tools: {
            },
        },
    };
};

const state = getDefaultState();

export default state;
